import FlashCard, { StrapiFlashCardData } from '@/components/FlashCards/card';
import {
  TextWithDropShadow,
  TextWithDropShadowColor,
} from '../TextWithDropShadow';

interface FlashCardsProps {
  body: {
    id: number;
    content: string;
    hidden: boolean;
  };
  data: StrapiFlashCardData[];
}

export default function FlashCards({ items }: { items: FlashCardsProps }) {
  return (
    <>
      <div className='mx-auto mb-9 w-full text-center md:w-8/12'>
        <h2 className='mb-10 text-center'>
          <TextWithDropShadow text={items.body.content} displayShadow={false} />
        </h2>
      </div>
      <div className='flex w-full flex-wrap justify-center gap-6 lg:gap-8'>
        {items &&
          items.data.map((item, idx) => <FlashCard data={item} key={idx} />)}
      </div>
    </>
  );
}
